import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tidanxinxi",
  "use": "icon-tidanxinxi-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-tidanxinxi\"><path d=\"M4.488 8.508h7.032v.784H4.488v-.784zm0 2.304h7.032v.784H4.488v-.784zm6.328-8.392v-.008c-.04.016-.08.032-.128.032a.439.439 0 01.056.48c.04.08.056.184.04.272.008.008.024.008.032.016v-.008h2.576v11.248H2.608V3.196h2.576a.433.433 0 01.12-.032l.024-.072c.096-.296.096-.464-.04-.664-.032-.008-.072-.016-.096-.032v.008h-3.36V15.22h12.344V2.42h-3.36zM4.488 6.156h7.032v.784H4.488v-.784zm6.448-4.136a.734.734 0 00-.736-.736h-.76A1.618 1.618 0 008 .396c-.616 0-1.176.352-1.44.888H5.8a.734.734 0 00-.736.736v1.912h5.856l.016-1.912zm-.592 1.384H5.648V2.076c0-.08.072-.152.152-.152h1.168l.072-.2a1.02 1.02 0 01.968-.688c.44 0 .824.28.968.688l.072.2h1.168c.08 0 .152.072.152.152v1.328h-.024z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tidanxinxi.svg
// module id = 513
// module chunks = 4